module.exports = __webpack_public_path__ + "img/上对齐2.366b0f44.svg";